module.exports = __webpack_public_path__ + "static/img/acil-passive.65c89b59.svg";